import ReportBase from 'app/models/report_base';

export default ReportBase.extend({
  reportType: 'shipment',
});



// WEBPACK FOOTER //
// ./app/models/shipment_report.js